module.exports = __webpack_public_path__ + "img/Ceular_RattyHablando.4e795d82.png";